export default __webpack_public_path__ + "static/media/play.2c130be8.svg";